import React from 'react';

export default function Br({ props }) {
    return <br {...props} />;
}
